import { render, staticRenderFns } from "./DragArea.vue?vue&type=template&id=5d63e843&scoped=true&"
import script from "./DragArea.vue?vue&type=script&lang=js&"
export * from "./DragArea.vue?vue&type=script&lang=js&"
import style0 from "./DragArea.vue?vue&type=style&index=0&id=5d63e843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63e843",
  null
  
)

export default component.exports